module.exports = __webpack_public_path__ + "img/participant-list-mobile-en.6a5efafb.jpg";